import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

/**
 * Render a button that logs out the user on click.
 *
 * The `logout` action used to be injected via `inject(({ store }) => ({ logout:
 * store.logout }))`; it now comes from useStores().
 */
const Logout = observer(function Logout() {
  const store = useStores();
  return <button onClick={() => store.logout()}>Logout</button>;
});

export default Logout;
